import { Box, Image, Spacer, Text } from '@jfs/ui-new'
import ic_copy from '../../../assets/images/ic_copy.png'
import { ErrorBoundary } from './ErrorBoundary'
import styles from './styles'
interface ListItemProps {
  item: any
  isEncryped: boolean
  onListItemAction: any
  index: number
}

const ListItem = ({ item, isEncryped, onListItemAction, index }: ListItemProps) => {
  return (
    <Box {...styles.listItem.container} testID={'apiCredentialsItem-' + index}>
      <Box {...styles.listItem.leftContainer}>
        <Text {...styles.listItem.tittle} testID="key">{item.title}</Text>
        <Spacer {...styles.listItem.verticalSpacerProps} />
        <Text {...styles.listItem.subTittle}>
          {item.subTittle}
          {'  '}
        </Text>
      </Box>
      <Box {...styles.listItem.rightContainer}>
        <Text {...styles.listItem.value} testID={'value'}>
          {isEncryped && item.iconAction === 'LOCK'
            ? '****************************************************************'
            : item.value}
        </Text>
      </Box>

      {item.iconId && (
        <>
          <Spacer {...styles.listItem.horizonatalSpacerProps} />
          <Box
            onPress={(_evt) => {
              onListItemAction(item)
            }}
            underlayColor={'TRANSPARENT'}
            testID={`copy`}>
            <ErrorBoundary>
              <Image source={isEncryped && item.iconAction === 'LOCK' ? item.iconId : ic_copy} width={24} height={24} />
            </ErrorBoundary>
          </Box>
        </>
      )}
    </Box>
  )
}

export { ListItem }
